<template>
    <div class="h-100">
        <div v-if="$web.isDesktop" class="desktop">

            <h1 v-text="contents.select" class="desktop-title"/>

            <!-- Buttons -->
            <div class="row">

                <div v-for="(type, key) in types" :key="key"
                     class="col-6 text-center">

                    <ImageBtn
                            :value="type.value"
                            @click="selectBuildingType"
                            :text="type.text"
                            :subtitle="type.subtitle"
                            :src="icon(type)"/>

                </div>

            </div>
        </div>

        <BottomBg v-else>

            <!-- Logo -->
            <TopLogo class="mb-5"/>

            <!-- Text -->
            <p v-text="contents.select" class="select-label"/>

            <!-- Buttons -->
            <div class="row">

                <div v-for="(type, key) in types" :key="key"
                     class="col-6 text-center">

                    <ImageBtn
                            :value="type.value"
                            @click="selectBuildingType"
                            :text="type.text"
                            :subtitle="type.subtitle"
                            :src="icon(type)"/>

                </div>

            </div>

        </BottomBg>
    </div>
</template>

<script>
    import contents from "../contents/profile-types.json"
    import {types} from "@/data/profile"
    import ImageBtn from "../components/ImageBtn";
    import TopLogo from "../components/TopLogo";
    import BottomBg from "../components/BottomBg";

    export default {
        name: 'profile-types',
        components: {ImageBtn, TopLogo, BottomBg},
        mounted(){
            this.$registerEvent('Pagina', '3. Selezione tipologia');
        },
        data() {
            return {
                title: 'Profile types',
                types,
                contents
            };
        },
        methods: {
            selectBuildingType(buildingType) {
                this.$store.commit('setProfileType', buildingType);
                this.$router.push('/profile');
            },
            icon(type) {
                return require(`../assets/icons/${type.icon}.svg`);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .select-label {
        font-weight: bold;
        text-align: center;
        padding: 0 40px;
        margin-bottom: 40px;
        font-size: 18px;
        color: #121212;
    }

    .btn-icon {
        height: 100%;
    }

    .col-6 {
        padding: 0 10px;
        margin-bottom: 15px;
    }
</style>